import React from "react";

const Videoframe = ({ title, des, vidId }) => {
  const link = "https://www.youtube.com/watch?v=" + vidId;

  return (
    <article
      className="w-full h-auto flex flex-col items-center justify-center 
    rounded-2xl border-2 border-solid border-stone-700 shadow-lg shadow-slate-600"
    >
      <div className="p-5">
        <div>
          <iframe
            width="450"
            height="250"
            src={"https://www.youtube.com/embed/" + vidId}
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </div>

      <div className="pb-4 text-center">
        <a
          href={link}
          target={"_blank"}
          className="hover:underline underline-offset-2 text-xl"
        >
          <h2>{title}</h2>
        </a>
        <span>{des}</span>
      </div>
    </article>
  );
};

export default Videoframe;
